import { useQuery } from '@apollo/client';
import type { CommunityGroup } from '@communities/community-groups/domain';
import { GET_COMMUNITY_GROUPS } from '@communities/community-groups/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface CommunityGroupsQueryResponse {
  communityGroups: CommunityGroup[];
}

export function useCommunityGroups() {
  const { data, loading, error, refetch } = useQuery<CommunityGroupsQueryResponse>(GET_COMMUNITY_GROUPS, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  const communityGroups = data?.communityGroups || [];

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  return {
    data: communityGroups,
    loading,
    errors,
    refetch,
  };
}

export default useCommunityGroups;
